._BlogContent_scebi_1 ._image_scebi_1 {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}